// removed by extract-text-webpack-plugin
module.exports = {"menuText":"var(--menuText, #bfcbd9)","menuActiveText":"#409EFF","subMenuActiveText":"#f4f4f5","menuBg":"var(--menuBg, #304156)","menuHover":"var(--menuHover, #263445)","subMenuBg":"var(--subMenuBg, #1f2d3d)","subMenuHover":"#001528","sideBarWidth":"210px"};


//////////////////
// WEBPACK FOOTER
// ./src/styles/index.scss
// module id = yh13
// module chunks = 184